import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const yesNoBody = (rowData, field) => (rowData && rowData[field] ? 'Yes' : 'No');

const isAllowedValue = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'allowed';
  }
  return false;
};

const allowanceBody = (rowData) => {
  const allowed = isAllowedValue(rowData && rowData.allowance);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '7.5rem',
        padding: '0.35rem 0.85rem',
        borderRadius: '9999px',
        backgroundColor: allowed ? '#22c55e' : '#ef4444',
        color: '#ffffff',
        fontWeight: 600,
      }}
    >
      {allowed ? 'Allowed' : 'Disallowed'}
    </span>
  );
};

const actionsBody = (rowData, onEdit, onDelete, disableActions) => {
  if (disableActions) return null;

  return (
    <div className="flex align-items-center gap-2">
      <Button
        icon="pi pi-pencil"
        className="p-button-text"
        tooltip="Edit member"
        tooltipOptions={{ position: 'bottom' }}
        onClick={() => onEdit(rowData)}
      />
      <Button
        icon="pi pi-trash"
        className="p-button-text p-button-danger"
        tooltip="Delete member"
        tooltipOptions={{ position: 'bottom' }}
        onClick={() => onDelete(rowData)}
      />
    </div>
  );
};

const MembersTable = ({ members, loading, onEdit, onDelete, disableActions = false, emptyMessage, variant = 'full' }) => (
  <DataTable
    value={members}
    dataKey="id"
    loading={loading}
    emptyMessage={emptyMessage || 'No members found.'}
    scrollable
    scrollHeight="calc(100vh - 320px)"
    tableStyle={{ minWidth: '110rem' }}
    style={{ width: '100%' }}
  >
    <Column field="name" header="Name" sortable style={{ minWidth: '10rem' }} />
    <Column field="surname" header="Surname" sortable style={{ minWidth: '10rem' }} />
    <Column field="memberId" header="Member ID" sortable style={{ minWidth: '10rem' }} />
    {variant === 'support' && <Column header="Allowance" body={allowanceBody} style={{ minWidth: '11rem' }} />}
    {variant === 'support' && <Column header="Temporal" body={(rowData) => yesNoBody(rowData, 'temporal')} style={{ minWidth: '8rem' }} />}
    <Column field="locationName" header="Location" sortable style={{ minWidth: '12rem' }} />
    {variant !== 'support' && <Column field="groupId" header="Group" sortable style={{ minWidth: '8rem' }} />}
    {variant !== 'support' && <Column field="customerName" header="Customer" sortable style={{ minWidth: '12rem' }} />}
    {variant !== 'support' && <Column field="type" header="Type" sortable style={{ minWidth: '8rem' }} />}
    {variant !== 'support' && <Column header="Allowance" body={allowanceBody} style={{ minWidth: '11rem' }} />}
    {variant !== 'support' && <Column header="Temporal" body={(rowData) => yesNoBody(rowData, 'temporal')} style={{ minWidth: '8rem' }} />}
    {variant !== 'support' && <Column field="initDate" header="Init Date" sortable style={{ minWidth: '10rem' }} />}
    {variant !== 'support' && <Column field="endDate" header="End Date" sortable style={{ minWidth: '10rem' }} />}
    {variant !== 'support' && <Column field="email" header="Email" style={{ minWidth: '14rem' }} />}
    {variant !== 'support' && <Column field="purpose" header="Purpose" style={{ minWidth: '12rem' }} />}
    {variant !== 'support' && <Column field="mobile" header="Mobile" style={{ minWidth: '10rem' }} />}
    {variant !== 'support' && <Column header="Allowed Now" body={(rowData) => yesNoBody(rowData, 'allowedNow')} style={{ minWidth: '9rem' }} />}
    {!disableActions && (
      <Column
        header="Actions"
        body={(rowData) => actionsBody(rowData, onEdit, onDelete, disableActions)}
        frozen
        alignFrozen="right"
        style={{ minWidth: '8rem' }}
      />
    )}
  </DataTable>
);

export default MembersTable;
